import { Record, useSearchPerson } from '@ltvco/refresh-lib/v1';
import {
  AdvancedSearchURLParams,
  getPersonSearchParams,
} from '@ltvco/refresh-lib/v2';
import { useFeatureIsOn } from '@ltvco/refresh-lib/vendors';
import React, { useEffect } from 'react';

interface PersonFetcherProps {
  searchData: AdvancedSearchURLParams;
  // eslint-disable-next-line no-unused-vars
  setPersonResults: (results: Record[] | undefined) => void;
}

export function PersonFetcher({
  searchData,
  setPersonResults,
}: PersonFetcherProps) {
  const isInPartialAddressesVariation = useFeatureIsOn('OAR-1569');
  const updatedSearchData: AdvancedSearchURLParams = {
    ...searchData,
    ...(isInPartialAddressesVariation && { showPartialAddresses: true }),
  };

  const { data, isFetched, isError } = useSearchPerson({
    searchPersonBy: 'name',
    options: {
      personSearchParams: getPersonSearchParams(updatedSearchData),
      isOptout: false,
    },
  });

  useEffect(() => {
    if (isFetched) {
      // data will be an empty array [] if no results, or Record[] if results exist
      setPersonResults(isError ? [] : (data as Record[] | undefined));
    }
  }, [data, isFetched, isError, setPersonResults]);

  return <React.Fragment />;
}
